import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { DashboardDataFilters, ReportsPeriodDTO } from './ReportsDTO';

export function buildPeriodFilters(params: ReportsPeriodDTO): {
  filters: Pick<DashboardDataFilters, 'date_range'>;
  startDate: string | null;
  endDate: string | null;
} {
  const [startDate, endDate] =
    params.start_date || params.end_date
      ? [params.start_date ?? null, params.end_date ?? null]
      : buildDefaultPeriodDates();

  return {
    filters: {
      date_range: {
        start_date: startDate ? DateTime.fromISO(startDate).toISODate() : null,
        end_date: endDate ? DateTime.fromISO(endDate).toISODate() : null,
      },
    },
    startDate,
    endDate,
  };
}

export function usePeriodFilters(params: ReportsPeriodDTO) {
  return useMemo(
    () =>
      buildPeriodFilters({
        start_date: params.start_date,
        end_date: params.end_date,
      }),
    [params.start_date, params.end_date],
  );
}

function buildDefaultPeriodDates(): [string, string] {
  const now = DateTime.local();

  return [
    now.minus({ days: 6 }).startOf('day').toISO(),
    now.endOf('day').toISO(),
  ];
}

export function buildLast30DaysDates(): [string, string] {
  const now = DateTime.local();

  return [
    now.minus({ days: 29 }).startOf('day').toISO(),
    now.endOf('day').toISO(),
  ];
}
